const columns = [
    {
        title: "客户名称",
        dataIndex: "company",
        key: "company",
        ellipsis: true
    },
    {
        title: "合同编号",
        dataIndex: "erp_contract_number",
        ellipsis: true,
        key: "erp_contract_number"
    },
]

export default columns
